/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

// Note: This is a model for the tenancy of the application.

// If user does not have a tenantId, then the default tenantId will be used.
export const DEFAULT_TENANT_ID: string = 'touchplan';
